import { SoStatusEnum } from '@gtpl/shared-models/common-models';
import { PlantIdRequest } from '@gtpl/shared-models/masters';
import { SoNumbersModel } from '@gtpl/shared-models/sale-management';
import { Repository, EntityRepository } from 'typeorm';
import { StockIn } from '../stock-in.entity';


@EntityRepository(StockIn)
export class StockInRepository extends Repository<StockIn>{
}